export class WbFunkySentence {
  constructor() {
    this.init();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    document.querySelectorAll('.wb-funky-sentence')?.forEach((block => {
      block.querySelectorAll('.wb-funky-sentence__title u')?.forEach((underline, index) => {
        underline?.addEventListener('mouseout', e => {
          block.querySelectorAll(`.wb-funky-sentence__images`)?.forEach(item => item.classList.remove('--active'));
        })
        underline?.addEventListener('mouseenter', e => {
          const pos = {
            x: underline.offsetLeft,
            y: underline.offsetTop,
            width: underline.offsetWidth,
          }
          block.querySelectorAll(`.wb-funky-sentence__images`)?.forEach(item => item.classList.remove('--active'));
          const activeBlock = block.querySelector(`.wb-funky-sentence__images[data-loop="${index + 1}"]`);
          if (activeBlock) {
            activeBlock.classList.add('--active');
            activeBlock.style.left = `${pos.x}px`;
            activeBlock.style.top = `${pos.y}px`;
            activeBlock.style.width = `${pos.width}px`;
          }
        });
      });
    }));
  }

}
